/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type UserAddAddressInput = {
    readonly userId: string;
    readonly validateBuyerShipping?: boolean | null;
    readonly address: AddressInput;
    readonly clientMutationId?: string | null;
};
export type AddressInput = {
    readonly active?: unknown | null;
    readonly contact?: string | null;
    readonly city?: string | null;
    readonly company?: string | null;
    readonly country?: string | null;
    readonly firstName?: string | null;
    readonly lastName?: string | null;
    readonly label?: string | null;
    readonly line1?: string | null;
    readonly line2?: string | null;
    readonly phoneNumber?: string | null;
    readonly state?: string | null;
    readonly zipCode?: string | null;
};
export type drsmUserAddAddressMutationVariables = {
    readonly input: UserAddAddressInput;
};
export type drsmUserAddAddressMutationResponse = {
    readonly userAddAddress: {
        readonly address: {
            readonly serviceId: string | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
        } | null;
    } | null;
};
export type drsmUserAddAddressMutation = {
    readonly response: drsmUserAddAddressMutationResponse;
    readonly variables: drsmUserAddAddressMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "UserAddAddressInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstName",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "lastName",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "drsmUserAddAddressMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userAddAddress",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserAddAddressPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "address",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Address",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "drsmUserAddAddressMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "userAddAddress",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserAddAddressPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "address",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Address",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "id",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "drsmUserAddAddressMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/drsmUserAddAddressMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '246ed39a82c73155cabaa7cd79e9db13';
export default node;
